module.exports = __webpack_public_path__ + "img/datacredito.853afa5b.svg";